import * as React from 'react';

export const getItemValue = (keyName: string, defaultValue: any) => {
  try {
    const item = localStorage.getItem(keyName);

    if (item === null) return defaultValue;

    return JSON.parse(item).state;
  } catch (e) {
    return defaultValue;
  }
};

export const useLocalState = (keyName: string, initialState: any) => {
  const [state, setState] = React.useState(() => getItemValue(keyName, initialState));

  React.useEffect(() => {
    try {
      localStorage.setItem(keyName, JSON.stringify({ state }));
    } catch (e) {}
  }, [keyName, state]);

  return [state, setState];
};
